import { render, staticRenderFns } from "./createIssue.vue?vue&type=template&id=52d4baa5&"
import script from "./createIssue.vue?vue&type=script&lang=ts&"
export * from "./createIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports